import * as React from "react"

const ChevronLeft = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" {...props}>
    <path d="M5.3 8 9 4.3l.7.7-3 3 3 3-.7.7L5.3 8Z" />
  </svg>
)

export default ChevronLeft
